import { Tooltip } from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAppointmentsCalendar } from "../../../../../../actions/accidentDashboard";
import {
  attendedAppointment,
  cancelledAppointment,
  getAppointmentSession,
  postAppointment,
  unAttendedAppointment,
  updateAppointment,
} from "../../../../../../actions/appointments";
import { openNewForm } from "../../../../../../actions/formsState";
import {
  downloadAppointmentSessionReport,
  getAppointmentSessionReportBase64,
} from "../../../../../../actions/reports";
import { CODIGO_AUDITORIA, registrarAccionFrontend } from "../../../../../../actions/audit";
import { convertDateTimeToNet } from "../../../../../../utils/datetimeUtils";
import { downloadFile } from "../../../../../../utils/filesUtils";
import snackbarUtils from "../../../../../../utils/snackbarUtils";
import CustomDialog from "../../../../../commons/dialog/customDialog";
import PrintAndDownloadDialog from "../../../../../commons/dialog/PrintAndDownloadDialog";
import PdfView from "../../../../../commons/file/pdfView";
import { StyledAppointmentsDetail } from "../../../../../styled/appointments";
import { StyledFormHeader } from "../../../../../styled/form";
import AddAppointment from "../addAppointment";
import AppointmentPrintSession from "../session/appointmentPrintSession";
import AppointmentDetailCards from "./appointmentDetailCards";

const AppointmentDetail = ({
  data,
  open,
  handleClose,
  handleOpenConfirmDialog,
  openEdit,
  handleCloseEdit,
  handleOpenEdit,
  appointment,
  cargaFPT,
  idArt,
}) => {
  const dispatch = useDispatch();

  const accident = useSelector((state) => state.accidentDashboard.accident);
  const reportSession = useSelector(
    (state) => state.reports.appointmentSession,
  );
  const documentation = useSelector(
    (state) => state.accidentDashboard.availableDocumentsToAdd,
  );

  const [appointmentsIds, setAppointmentsIds] = useState([]);
  const [openPrintSession, setOpenPrintSession] = useState(false);
  const [openReportSession, setOpenReportSession] = useState(false);

  const attended = (appointment) => {
    dispatch(
      attendedAppointment(
        appointment.idTurnoSiniestro,
        accident.mlCloudCoreArtId,
      ),
    ).then(() => {
      dispatch(
        getAppointmentsCalendar(
          accident.idSiniestro,
          accident.mlCloudCoreArtId,
        ),
      );
      handleClose();
      snackbarUtils.success("Turno marcado como concurrido correctamente");
    });
  };

  const unAttended = (appointment) => {
    dispatch(
      unAttendedAppointment(
        appointment.idTurnoSiniestro,
        accident.mlCloudCoreArtId,
      ),
    ).then(() => {
      dispatch(
        getAppointmentsCalendar(
          accident.idSiniestro,
          accident.mlCloudCoreArtId,
        ),
      );
      handleClose();
      snackbarUtils.success("Turno marcado como ausente correctamente");
    });
  };

  const cancelled = (appointment) => {
    dispatch(
      cancelledAppointment(
        appointment.idTurnoSiniestro,
        accident.mlCloudCoreArtId,
      ),
    ).then(() => {
      dispatch(
        getAppointmentsCalendar(
          accident.idSiniestro,
          accident.mlCloudCoreArtId,
        ),
      );
      handleClose();
      snackbarUtils.success("Turno anulado correctamente");
    });
  };

  const handleEditAppointment = (
    values,
    createProfessional,
    isUpdateAppointment,
  ) => {
    const model = {
      ...values,
      fechaHora: convertDateTimeToNet(values.fechaHora),
      traslado: values.traslado || false,
    };

    if (isUpdateAppointment) {
      dispatch(
        updateAppointment(
          values.idTurnoSiniestro,
          accident.mlCloudCoreArtId,
          model,
        ),
      ).then(() => {
        dispatch(
          getAppointmentsCalendar(
            accident.idSiniestro,
            accident.mlCloudCoreArtId,
          ),
        );
        snackbarUtils.success("Turno modificado correctamente");
      });
    } else {
      dispatch(
        cancelledAppointment(
          values.idTurnoSiniestro,
          accident.mlCloudCoreArtId,
        ),
      ).then(() => {
        const { especialidadNombre, estado, idTurnoSiniestro, ...newModel } =
          model;
        dispatch(postAppointment(newModel)).then(() => {
          dispatch(
            getAppointmentsCalendar(
              accident.idSiniestro,
              accident.mlCloudCoreArtId,
            ),
          );
        });
      });
      snackbarUtils.success("Se creó el nuevo turno correctamente");
    }

    if (cargaFPT && !isUpdateAppointment && values.traslado) {
      dispatch(
        openNewForm("Fpt", "Formulario de Pedido de Traslado", {
          professionalName: values.profesionalApellidoNombre,
          specialityName: values.especialidadNombre,
          appointmentDates: [values.fechaHora],
          appointmentsIds: [values.idTurnoSiniestro],
        }),
      );
    }
    handleCloseEdit();
    handleClose();
  };

  const handleOpenPrintSession = (appointment) => {
    dispatch(
      getAppointmentSession(
        appointment.idTurnoSiniestro,
        appointment.mlCloudCoreArtId,
      ),
    );
    setOpenPrintSession(true);
  };

  const handleClosePrintSession = () => {
    setOpenPrintSession(false);
  };

  const handleSubmitPrintSession = (data) => {
    const appointmentIds = [];
    data.forEach((t) => {
      appointmentIds.push(t.id);
    });
    setAppointmentsIds(appointmentIds);
    dispatch(getAppointmentSessionReportBase64(appointmentIds, idArt));
    setOpenReportSession(true);
  };

  const handleCloseReportSession = () => {
    setOpenReportSession(false);
    handleClosePrintSession();
    handleClose();
    setAppointmentsIds([]);
  };

  const handleDownloadSessionReport = () => {
    dispatch(registrarAccionFrontend({
      idArt,
      code: CODIGO_AUDITORIA.DESCARGA_REPORTE_SESION_TURNOS,
      siniestro: accident?.idSiniestro,
      numeroDocumento: accident?.documento,
      requestInput: appointmentsIds.join(","),
    }));
    dispatch(downloadAppointmentSessionReport(appointmentsIds, idArt)).then(
      (response) => {
        downloadFile(response.value.data, "Reporte Sesión de Turnos.pdf");
      },
    );
  };

  return (
    <div>
      <CustomDialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
      >
        <StyledAppointmentsDetail.TitleContainer>
          <StyledAppointmentsDetail.Title>
            TURNOS
          </StyledAppointmentsDetail.Title>
          <Tooltip title="Cerrar">
            <StyledFormHeader.CloseIcon onClick={handleClose} />
          </Tooltip>
        </StyledAppointmentsDetail.TitleContainer>
        <StyledAppointmentsDetail.AppointmentsContainer>
          <AppointmentDetailCards
            data={data}
            onAttended={attended}
            onUnAttended={unAttended}
            onEdit={handleOpenEdit}
            onCancelled={cancelled}
            onPrintSession={handleOpenPrintSession}
          />
        </StyledAppointmentsDetail.AppointmentsContainer>
      </CustomDialog>
      <AppointmentPrintSession
        open={openPrintSession}
        handleClose={handleClosePrintSession}
        handleSubmit={handleSubmitPrintSession}
      />
      <PrintAndDownloadDialog
        maxWidth="lg"
        openModal={openReportSession}
        handleCloseModal={handleCloseReportSession}
        childComponent={
          reportSession.data.base64 && (
            <PdfView
              file={`data:application/pdf;base64,${reportSession.data.base64}`}
            />
          )
        }
        loading={reportSession.isFetching}
        title="REPORTE SESIÓN DE TURNOS"
        reactToPrintProps={{ suppressErrors: true }}
        handleDownload={handleDownloadSessionReport}
      />
      <AddAppointment
        open={openEdit}
        handleOpenConfirmDialog={handleOpenConfirmDialog}
        handleSubmit={handleEditAppointment}
        appointmentModel={appointment}
        artId={accident.mlCloudCoreArtId}
        documentation={documentation}
        openInCalendar={false}
        enablePastDates={false}
        appointmentDetail={true}
      />
    </div>
  );
};

export default AppointmentDetail;
